module.exports = __webpack_public_path__ + "img/clipboard-blue-outline.e268fa84.svg";